import React from 'react';
import { Sparkles, Smile, Stethoscope, AlignCenter } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const cards = [
  { key: 'implants', icon: Sparkles },
  { key: 'smile', icon: Smile },
  { key: 'general', icon: Stethoscope },
  { key: 'orthodontics', icon: AlignCenter }
];

const ServicesSection = () => {
  const { t } = useLanguage();

  return (
    <section className="section-padding">
      <div className="container-custom">
        <h2 className="text-3xl md:text-4xl font-bold mb-3 text-[#0f172a]">{t('services.title')}</h2>
        <p className="text-[#475569] mb-10 text-lg">{t('services.subtitle')}</p>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {cards.map(({ key, icon: Icon }) => (
            <article key={key} className="glass-card p-6 hover:shadow-md transition-shadow">
              <div className="w-10 h-10 rounded-xl bg-sky-100 text-sky-700 grid place-items-center mb-4">
                <Icon size={20} />
              </div>
              <h3 className="text-xl font-semibold text-[#0f172a] mb-2">{t(`services.${key}.title`)}</h3>
              <p className="text-sm leading-6 text-[#475569]">{t(`services.${key}.description`)}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
